


































import { Component, Vue } from "vue-property-decorator";
@Component
export default class NewShowGettingStarted extends Vue {
  get authURL(): string {
    return process.env.VUE_APP_DOG_SITE + "/square-authorize";
  }

  validate(): Array<string>{
    console.log("validate")
    return []
  }
}
